import en_US from "./en_US.json";
import sv_FI from "./sv_FI.json";
import fi_FI from "./fi_FI.json";

export default {en_US, sv_FI, fi_FI};
